namespace Areas.Dialogs.CreateEic {
    "use strict";

    export class CreateEicDialog extends Areas.BaseDialog {

        constructor(closeHandler: (dialogResult: DialogResult, data: any) => void) {
            super("CreateEic", closeHandler);
        }

        protected ok = (e: any) => {
            const form = $("#CreateEicForm").dxForm("instance");
            const result: any = form.validate();

            if (result.isValid) {

                const newData: any = form.option("formData");

                sendRequest("/Dialog/CreateEic/Post", JSON.stringify(newData), "POST", () => {
                    this.close(DialogResult.Ok, null);
                });
            }
        }
    }

    export function projectIdSelected(e: any) {
        const form = $("#CreateEicForm").dxForm("instance");
        var projectNameControl: DevExpress.ui.dxTextBox = form.getEditor("ProjectName") as DevExpress.ui.dxTextBox;

        projectNameControl.option("disabled", e.selectedItem);
    }

    export function projectNameChanged(e: any) {
        const form = $("#CreateEicForm").dxForm("instance");

        var projectIdControl: DevExpress.ui.dxLookup = form
            .getEditor("ProjectId") as DevExpress.ui.dxLookup;

        projectIdControl.option("disabled", e.value);
    }

    export function validateForm(e: any) {
        const form = $("#CreateEicForm").dxForm("instance");
        const formData = form.option("formData");

        if (Areas.isEmpty(formData.ProjectId) && Areas.isEmpty(formData.ProjectName)) {
            return false;
        }

        return true;
    }
}
